import { createStyles } from '@mantine/core';
var useStyles = createStyles({
  calendarSelectGroup: {},
  calendarSelect: {},
  calendarLabel: {}
});
export default useStyles;